import { stringify } from 'query-string'
import React from 'react'
import { useLocation } from 'react-router-dom'

import LoadingPage from '../data/LoadingPage'
import { useEnsureLoggedInUserMeQueryQuery } from '../graphql'
import { GCLID_STORAGE_KEY } from '../lib/gclid.constants'

function getRedirectSearch(search: string): string {
  const searchParams = new URLSearchParams(search)
  const gclid = searchParams.get(GCLID_STORAGE_KEY)
  if (!gclid) return search

  try {
    window.sessionStorage.setItem(GCLID_STORAGE_KEY, gclid)
  } catch (error) {}

  searchParams.delete(GCLID_STORAGE_KEY)
  const redirectSearch = searchParams.toString()
  return redirectSearch ? `?${redirectSearch}` : ''
}

const EnsureLoggedInUser: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { pathname, search } = useLocation()
  const { data, loading, error } = useEnsureLoggedInUserMeQueryQuery()

  // Throw on request errors
  if (error) {
    throw new Error(error.message)
  }

  // If there is no data yet show loading state
  if (!data || loading) {
    return <LoadingPage />
  }

  // If there is a response, but:
  // 1. no user is available
  // 2. a user is available but doesn't have a verified email
  // redirect to authentication
  if (data && (!data.me || (data.me && !data.me.hasVerifiedEmail))) {
    if (typeof window !== 'undefined') {
      const origin = new URLSearchParams(search).get('origin')
      const venueId = new URLSearchParams(search).get('venueId')
      window.location.href = `/auth?${stringify({
        redirectApp: 'phoenix',
        redirectPath: `/phoenix${pathname}${getRedirectSearch(search)}`,
        venueId,
        origin,
      })}`
    }
    return null
  }

  // If a valid user can be fetched render the corresponding children of this component
  return <>{children}</>
}

export default EnsureLoggedInUser
